export const AnalyticsActions = {
    STEP_SELECTED: (step) => `Step${ step }Selected`,
  }
  
  export const AnalyticsEvents = {
    CONSULTANT: 'Consultant',
  }
  